<template>
  <div class="customer-temp-form">
    <el-container>
      <el-aside width="250px">
        <erp-tree-status @node-click="nodeClick" />
      </el-aside>
      <el-main>
        <el-tabs type="border-card" v-model="activeName">
          <el-tab-pane label="列表" name="CustomerTempFormList">
            <CustomerTempFormList v-if="activeName === 'CustomerTempFormList'" />
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import ErpTreeStatus from "../Common/erp-tree-status";
import CustomerTempFormList from "./components/CustomerTempFormList";
export default {
  name: "CustomerTempForm",
  components: {CustomerTempFormList, ErpTreeStatus},
  provide(){
    return{
      mainObj:this.mainObj
    }
  },
  data() {
    return {
      mainObj:{
        house_name:"",
        house_id:"",
        project_id:"",
      },
      activeName: "CustomerTempFormList",
    };
  },
  methods:{
    nodeClick(data) {
      const that=this;
      that.mainObj.house_name = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      that.mainObj.project_id = data.tree[0].pindex_id;
      if (data.tree[data.tree.length - 1].type === "room") {
        that.mainObj.house_id = data.tree[data.tree.length - 1].id;
      } else {
        that.mainObj.house_id = 0;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-temp-form{
  padding: 10px;

  /deep/ .el-main{
    padding: 10px 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/CustomerTempForm.vue